import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, SearchBar, CartBtn, TabContent, StoreFooter, FaHeart, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';

export default function AuroraLayout({ p }) {
  const T = p.storeTheme || {};
  const primary = T.primaryColor || "#6366f1";
  const secondary = T.secondaryColor || "#a5b4fc";
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: "Aurora • Creative",
    title: "Dreamy designs for creative souls.",
    subtitle: "Art, design, and creative lifestyle products that inspire every day.",
    primaryCta: "Discover More",
    secondaryCta: "Our Story",
  });
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "linear-gradient(160deg,#eef2ff 0%,#faf5ff 45%,#f0fdfa 100%)", fontFamily: T.fontFamily || "Poppins, sans-serif" }}>
      <nav className="sticky top-0 z-40 border-b border-indigo-100 bg-white/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-indigo-200" />
          <div>
            <p className="text-sm font-bold text-indigo-900">{p.storeInfo?.businessName}</p>
            <p className="text-[10px] font-medium" style={{ color: primary }}>{p.storeInfo?.businessCategory || text.storeInfo || "Store Info"}</p>
          </div>
          <SearchBar searchQuery={p.searchQuery} setSearchQuery={p.setSearchQuery} theme={T} className="flex-1 hidden md:block ml-3" />
          <div className="ml-auto flex items-center gap-2">
            <button onClick={p.handleGoToWishlist} className="relative p-2 rounded-xl border border-indigo-200 hover:bg-indigo-50" style={{ color: primary }}>
              <FaHeart className="text-base" />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 h-4 w-4 text-[9px] rounded-full text-white flex items-center justify-center" style={{ backgroundColor: primary }}>{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} />
            {p.userMenuElement}
          </div>
        </div>
      </nav>
      <section className="max-w-7xl mx-auto w-full px-4 pt-6">
        <div className="rounded-3xl overflow-hidden shadow-[0_20px_60px_rgba(99,102,241,0.3)]">
          <HeroImage p={p} themeId="aurora" className="h-[360px] md:h-[440px]">
            <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, ${primary}dd 0%, ${secondary}99 50%, transparent 100%)` }} />
            <div className="absolute inset-0 px-8 md:px-12 flex flex-col justify-center">
              <span className="inline-block text-[10px] uppercase tracking-[0.3em] font-bold px-3 py-1 rounded-full bg-white/15 backdrop-blur-sm text-white/80 mb-3 w-fit"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
              <h1 className="text-4xl md:text-5xl font-extrabold text-white leading-tight max-w-2xl"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
              <p className="mt-3 text-white/70 max-w-lg text-sm"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
              <div className="mt-6 flex gap-3">
                <button onClick={() => p.setActiveTab("products")} className="px-6 py-3 rounded-full text-sm font-bold text-white shadow-lg" style={{ backgroundColor: primary }}><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
                <button onClick={() => p.setActiveTab("details")} className="px-6 py-3 rounded-full text-sm font-semibold text-white/75 border border-white/30 backdrop-blur-sm"><InlineEditableText p={p} field="secondaryCtaText" value={copy.secondaryCta}>{copy.secondaryCta}</InlineEditableText></button>
              </div>
            </div>
          </HeroImage>
        </div>
        <div className="mt-4 grid grid-cols-3 gap-3">
          {[{l:text.products || "Products",v:p.filteredProducts?.length||0,c:"bg-indigo-50 border-indigo-200 text-indigo-900"},{l:text.services || "Services",v:p.filteredServices?.length||0,c:"bg-purple-50 border-purple-200 text-purple-900"},{l:"48h",v:"48h",c:"bg-violet-50 border-violet-200 text-violet-900"}].map(s => (
            <div key={s.l} className={`rounded-2xl border px-4 py-3 ${s.c}`}>
              <p className="text-[11px] font-semibold">{s.l}</p>
              <p className="text-xl font-extrabold mt-0.5">{s.v}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="max-w-7xl mx-auto w-full px-4 mt-5">
        <div className="rounded-2xl border border-indigo-100 bg-white/80 p-1.5 flex gap-1.5 overflow-x-auto">
          {[["products", getTabLabel(p, "products")],["services", getTabLabel(p, "services")],["details", getTabLabel(p, "details")]].map(([k,l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className="px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition" style={p.activeTab===k ? { backgroundColor: primary, color:"#fff" } : { color:"#3730a3" }}>{l}</button>
          ))}
        </div>
      </section>
      <section className="flex-1 max-w-7xl mx-auto w-full px-4 py-6"><TabContent p={p} /></section>
      <StoreFooter p={p} />
    </div>
  );
}

// ─── Spice ───────────────────────────────────────────────────────────────────